module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Preferences")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loadingMessage) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.debugMyRecord
    }
  }, [_c('v-list-item-title', [_vm._v("Debug my Record")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 grey--text"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.$router.push('/templates')
      }
    }
  }, [_vm._v("Templates")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.sendTestEmail
    }
  }, [_vm._v("Test Email")])], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "color": "blue"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: 0,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        Email\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 1,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        SMS\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        Billing\n    ")]), _vm._v(" "), _c('v-tab-item', {
    key: 0
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_vm._v("\n                        Email Signature"), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px",
      "height": "200px"
    }
  }, [_c('HtmlEditor', {
    attrs: {
      "height": 180
    },
    model: {
      value: (_vm.email.signature),
      callback: function($$v) {
        _vm.$set(_vm.email, "signature", $$v)
      },
      expression: "email.signature"
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Automatic CC"
    },
    model: {
      value: (_vm.email.cc),
      callback: function($$v) {
        _vm.$set(_vm.email, "cc", $$v)
      },
      expression: "email.cc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Automatic BCC"
    },
    model: {
      value: (_vm.email.bcc),
      callback: function($$v) {
        _vm.$set(_vm.email, "bcc", $$v)
      },
      expression: "email.bcc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email for Billing"
    },
    model: {
      value: (_vm.email.billing),
      callback: function($$v) {
        _vm.$set(_vm.email, "billing", $$v)
      },
      expression: "email.billing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element-label"
  }, [_vm._v("Outbound email can come from the brokers email address")]), _vm._v(" "), _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "label": "Send from Broker",
      "xhide-details": ""
    },
    model: {
      value: (_vm.email.broker),
      callback: function($$v) {
        _vm.$set(_vm.email, "broker", $$v)
      },
      expression: "email.broker"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "label": "Copy me Privately",
      "hide-details": ""
    },
    model: {
      value: (_vm.email.copyMe),
      callback: function($$v) {
        _vm.$set(_vm.email, "copyMe", $$v)
      },
      expression: "email.copyMe"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element-label"
  }, [_vm._v("Everything will be copied to you. Email will be tagged with 'TACO-SENT' so you can autofilter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Prefix SMS With"
    },
    model: {
      value: (_vm.sms.prefix),
      callback: function($$v) {
        _vm.$set(_vm.sms, "prefix", $$v)
      },
      expression: "sms.prefix"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Suffix SMS With"
    },
    model: {
      value: (_vm.sms.suffix),
      callback: function($$v) {
        _vm.$set(_vm.sms, "suffix", $$v)
      },
      expression: "sms.suffix"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Email for Billing (if different to yours)"
    },
    model: {
      value: (_vm.billing.email),
      callback: function($$v) {
        _vm.$set(_vm.billing, "email", $$v)
      },
      expression: "billing.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Direct Debit Ref"
    },
    model: {
      value: (_vm.billing.directDebitRef),
      callback: function($$v) {
        _vm.$set(_vm.billing, "directDebitRef", $$v)
      },
      expression: "billing.directDebitRef"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Billing Entity and Address"
    },
    model: {
      value: (_vm.billing.entity),
      callback: function($$v) {
        _vm.$set(_vm.billing, "entity", $$v)
      },
      expression: "billing.entity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2f583f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preferences.vue
// module id = 2519
// module chunks = 1